import React, { useEffect, useState } from "react";
import { GoogleApiWrapper, Map, Marker } from "google-maps-react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";

const GOOGLE_MAP_API_KEY = "AIzaSyDEDQua9g-ZxsqRcSNbNdf6r2NkcAfTtC4";

const MDGoogleMap = ({ selectedPosition, formik, formikKeyName }) => {
  const [center, setCenter] = useState({
    lat: selectedPosition.lat ? selectedPosition.lat : 23.0225,
    lng: selectedPosition.lng ? selectedPosition.lat : 72.5714,
  });
  var myStyles = [
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
  ];

  const handleMapClick = (mapProps, map, clickEvent) => {
    if (clickEvent.latLng) {
      const lat = clickEvent.latLng.lat();
      const lng = clickEvent.latLng.lng();
      formik?.setFieldValue("latitude", lat);
      formik?.setFieldValue("longitude", lng);
      setCenter({ lat, lng });
      geocodeLatLng(lat, lng);
    }
  };

  useEffect(() => {
    if (selectedPosition && selectedPosition.lat && selectedPosition.lng) {
      const updatedPosition = {
        lat: parseFloat(selectedPosition.lat),
        lng: parseFloat(selectedPosition.lng),
      };
      setCenter(updatedPosition);
    }
  }, [selectedPosition]);

  // const geocodeLatLng = (lat, lng) => {
  //   const latlng = { lat, lng };

  //   const geocoder = new window.google.maps.Geocoder();
  //   if (geocoder) {
  //     geocoder.geocode({ location: latlng }, (results, status) => {
  //       console.log("results: ", results[0].formatted_address);
  //       if (status === "OK") {
  //         if (results?.[0]) {
  //           formik?.setFieldValue(formikKeyName, results[0].formatted_address);
  //           // Handle additional logic if needed
  //         } else {
  //           console.error("No results found");
  //         }
  //       } else {
  //         console.error("No results found");
  //       }
  //     });
  //   }
  // };

  const geocodeLatLng = (lat, lng) => {
    const latlng = `${lat},${lng}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng}&key=${GOOGLE_MAP_API_KEY}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.results?.length) {
          const address = result.results[0].formatted_address;
          formik?.setFieldValue(formikKeyName, address);
        } else {
          console.error("No address found");
        }
      })
      .catch((error) => console.error("Geocode error:", error));
  };

  return (
    <MDBox sx={{ position: "relative !important", width: "100%", height: "350px" }}>
      <Map
        google={window.google}
        zoom={14}
        style={{
          height: "100%",
          zIndex: 1,
          marginBottom: "15px",
          position: "absoulte !important",
          width: "100%",
        }}
        initialCenter={center}
        center={center}
        onClick={handleMapClick}
      >
        <Marker position={center} />
      </Map>
    </MDBox>
  );
};

MDGoogleMap.propTypes = {
  selectedPosition: PropTypes.object,
  handleClick: PropTypes.func.isRequired,
  formik: PropTypes.object,
  formikKeyName: PropTypes.string,
};

export default GoogleApiWrapper((props) => ({
  apiKey: GOOGLE_MAP_API_KEY,
  language: "en",
  libraries: ["places"],
}))(MDGoogleMap);
